import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let gtag: Function;
declare var AOS: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'gigmor-web';

  constructor(private router: Router) {}

  ngOnInit(): void {
    AOS.init({
      offset: 120,
      duration: 400,
      easing: 'ease',
      once: true,
      mirror: false,
      anchorPlacement: 'top-bottom',
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag('config', 'G-6NH29NYN3P', { page_path: event.urlAfterRedirects });

        // Re-measure animated elements after the new route renders, otherwise
        // [data-aos] elements can stay hidden (opacity:0) on SPA navigation.
        setTimeout(() => AOS.refreshHard(), 300);
      });
  }
}
